export default "__VITE_ASSET__Cfw5o8F4__"